class ClaimStatus {
  constructor(data) {
    data = data || {};
    this.id = data.id;
    this.name = data.name;
    this.active = data.active;
    this.constant = data.constant;
    this.display_order = data.display_order;
  }
}

export default ClaimStatus;
